import React, {useEffect, useState} from 'react';
import {Button, Col, Row, Spinner} from 'react-bootstrap';
import Dropdown from "../../../../primer/Dropdown";
import Input from '../../../../common/Input';
import {
    getCountryOptions,
    getDefaultOptionByValue,
    getDOYOptions, getGeneratedMaskCodeCLient,
    getMainInstallation,
    getOptionsByData,
    getVatCategoryAbroadOptions,
    getVatCategoryOptions,
    isValidEmail
} from '../../../../../_helpers/commonFunctions';
import {useSelector} from "react-redux";
import {setSaveEditSupplier} from "../../../../../_reducers/activitySlice";
import {
    setEditSupplier,
    setEditContactPoint, setSupplierMovementsSearchByBalance,
    setEditBankInfo,
    resetEditBankInfo,
} from '../../../../../_reducers/DataPanel/Suppliers/supplierSlice';
import getMyData from '../../../../../_helpers/sharedmydata';
import TextArea from '../../../../common/TextArea';
import EditableTable from '../../../../primer/Editable-Table';
import {
    findObjectFromArrayOfObjects,
    getLabelByValue,
    getObjectFromArrayOfObjects
} from '../../../../../_helpers/helperFunctions';
import {toast} from 'react-toastify';
import Checkbox from '../../../../common/CheckBox';
import {fetchSuppliersSettings} from '../../../../../_apis/api';
import axios from "axios";
import LogTable from "../../../../primer/LogTable";
import {extendedBankOptions} from "../../../../../_data/dummy_banks";
import {openSupplierMovementsReport} from "../../../../../_helpers/tabOpeners";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";
import {useTranslation} from "../../../../../hooks/useTranslation";

const EditSupplierGeneral = ({tabKey}) => {
    const {t, locale} = useTranslation();
    const dispatch = useTaggedDispatch({tabKey});
    const SUPPLIERS_DATA = useSelector((state) => state.SUPPLIERS_DATA);
    const editSupplier = useSelector((state) => state.SUPPLIERS_DATA.editSupplier[tabKey]);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const company = useSelector(state => state.COMPANY_DATA.company)
    const supplierCategories = getObjectFromArrayOfObjects(SUPPLIERS_DATA.suppliersSettings.categories, 'active', 'isActive');
    const [supplierCategoriesOption, setSupplierCategoriesOption] = useState([]);
    const zeroVatReasonOptions = getMyData({type: 'zerovatreason'});
    let vatCategoryList = (editSupplier.categoryName === "Supplier within E.U." || editSupplier.categoryName === "Supplier outside E.U." || (editSupplier.categoryName === "Retail" && editSupplier.country !== "GR")) ? getVatCategoryAbroadOptions() : getVatCategoryOptions();
    const [bankInfoIncrKey, setBankInfoIncrKey] = useState(0);
    const [loadingTaxis, setLoadingTaxis] = useState(false);

    const availableTags = SUPPLIERS_DATA.suppliersSettings?.tags || [];
    const tagOptions = availableTags.map((o) => ({value: o, label: o}));

    useEffect(() => {
        setBankInfoIncrKey(bankInfoIncrKey + 1);
    }, [editSupplier?.bankInfo])

    useEffect(() => {
        let retailGroup = ["1"];
        if (retailGroup.includes(editSupplier.category)) {
            setSupplierCategoriesOption(getOptionsByData(supplierCategories.filter((el) => retailGroup.includes(el._id)), '_id', 'category'));
        } else {
            setSupplierCategoriesOption(getOptionsByData(supplierCategories.filter((el) => !retailGroup.includes(el._id)), '_id', 'category'));
        }
    }, [editSupplier])

    const isValidCustomVat = (value) => {
        let error;
        if (+value > 100) {
            error = 'Can not be greater than 100.';
        }
        return error;
    }
    const supplierContactPointsColumns = [
        {
            name: t("General.no"),
            field: "no",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.contactName"),
            field: "name",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.mobilePhone"),
            field: "mobile",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.landline"),
            field: "landline",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.otherPhone"),
            field: "otherPhone",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.email"),
            field: "email",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.contactNotes"),
            field: "contactNotes",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
    ]

    const supplierBankInfoColumns = [
        {
            name: t('ClientsGeneralEdit.bankInfoTable.bankFriendlyName'),
            field: "bankFriendlyName",
            editable: true,
            width: "20%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.bankInfoTable.bankInstitute'),
            field: "bankInstitute",
            editable: true,
            width: "30%",
            inputType: {
                type: 'select',
                options: extendedBankOptions,
            }
        },
        {
            name: "IBAN",
            field: "iban",
            editable: true,
            width: "50%",
            inputType: {
                type: 'text',
            }
        },
    ]
    useEffect(() => {
        dispatch(fetchSuppliersSettings({
            company: company.id,
            year: company.year.toString(),
            isActive: "active"
        }));
    }, []);

    useEffect(() => {
        setTableColumns(supplierContactPointsColumns.slice());
        setBankInfoTableColumns(supplierBankInfoColumns.slice());
    }, [locale])

    const [tableColumns, setTableColumns] = useState(supplierContactPointsColumns.slice())
    const [bankInfoTableColumns, setBankInfoTableColumns] = useState(supplierBankInfoColumns.slice())
    const [showErrors, setShowErrors] = useState(false)
    // Retail, Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.: Select Greece, Accept only Greece, show only Greece
    let countriesList = getCountryOptions("greece");
    if (editSupplier.categoryName === "Supplier within E.U.") {
        // Update country list for inside EU.
        // Supplier inside E.U., show only countries within E.U. except Greece
        countriesList = getCountryOptions("insideEU");
    } else if (editSupplier.categoryName === "Supplier outside E.U.") {
        // Update country list for outside EU
        // outside E.U., show only countries outside E.U.
        countriesList = getCountryOptions("outsideEU");
    } else if (editSupplier.categoryName === "Retail") {
        countriesList = (getCountryOptions('all'));
    } else {
        // Retail, Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.:
        // Select Greece, Accept only Greece, show only Greece
        countriesList = getCountryOptions("greece");
    }
    let disabledFields = false;
    if (editSupplier.category === undefined || editSupplier.category === '') {
        disabledFields = true;
    }
    const apiURL2 = process.env.REACT_APP_API_URL2;

    const fetchViesDetails = async (vat, country) => {
        let jsonData = {
            vatNumber: vat,
            country: country
        }
        if (vat === "" || vat === undefined) {
            toast.error("Please input a vat Number to check.");
        } else if (country === "" || country === undefined) {
            toast.error("Please select a country for VIES check.");
        } else {
            const abort = axios.CancelToken.source();
            const timer = setTimeout(() => abort.cancel(`timeout`), 10000);
            setLoadingTaxis(true);
            await axios.post(apiURL2 + `/supplier/fetch-vies-details/`, JSON.stringify(jsonData), {headers: {'Content-Type': 'application/json'}})
                .then((res) => {
                    if (res.data && res.data.status === "200") {
                        if (!ACTIVITY.saveEditSupplier) dispatch(setSaveEditSupplier(true));

                        clearTimeout(timer)
                        let companyDetails = res.data.data;
                        if (companyDetails.valid === true) {
                            let cloneSupplier = Object.assign({}, editSupplier);
                            cloneSupplier.name = companyDetails?.name !== undefined ? companyDetails?.name : "";
                            const address = companyDetails?.address.split(",");
                            cloneSupplier.postalCode = address[2] !== undefined ? address[2].split(" ")[1] : "";
                            cloneSupplier.address = address[1] !== undefined ? address[1] : "";
                            cloneSupplier.city = address[2] !== undefined ? address[2].split(" ")[2] : "";
                            cloneSupplier.vatCategory = 'Zero VAT';
                            cloneSupplier.vatReason = "14";
                            let updatedContactPoints = cloneSupplier.contactPoints.slice();
                            let newContacts = {
                                name: cloneSupplier.name,
                                email: cloneSupplier.email,
                                mobile: cloneSupplier.phone,
                            };
                            updatedContactPoints["0"] = {...updatedContactPoints["0"], ...newContacts};
                            let defaultInstallation = [
                                {
                                    id: 0,
                                    no: 0,
                                    type: getMainInstallation()?.value,
                                    address: cloneSupplier.address,
                                    DOY: cloneSupplier.DOY,
                                    city: cloneSupplier.city,
                                    county: cloneSupplier.county,
                                    vatCategory: cloneSupplier.vatCategory,
                                    vatReason: cloneSupplier.vatReason,
                                    customVat: cloneSupplier.customVat,
                                    postalCode: cloneSupplier.postalCode
                                },
                            ];
                            dispatch(setEditSupplier({
                                ...cloneSupplier,
                                contactPoints: updatedContactPoints,
                                installations: defaultInstallation
                            }));
                            toast.success(res.data.message);
                        } else {
                            toast.error("VAT Number with this country was not found on VIES");
                        }
                    } else {
                        console.log(res)
                        toast.error(res.data.message);
                    }
                    setLoadingTaxis(false);
                })
                .catch((error) => {
                    setLoadingTaxis(false);
                    console.log(error);
                    if (error.response?.status === 400) {
                        alert({
                            message: error.response.data?.Error ? error.response.data?.Error : error?.message === "timeout" ? "Timeout. Please try again later!" : error.code,
                            type: 'warning',
                        })
                    }
                });
        }
    };

    const fetchTaxisNetDetails = async (data) => {
        let jsonData = {
            vatNumber: data,
            onlyAADE: "true"
        }
        if (data === "" || data === undefined) {
            return toast.error("Παρακαλώ εισάγετε ΑΦΜ για έλεγχο.");
        }
        const abort = axios.CancelToken.source();
        const timer = setTimeout(() => abort.cancel(`timeout`), 10000);
        setLoadingTaxis(true);
        await axios.post(apiURL2 + `/supplier/fetch-vat-details/`, JSON.stringify(jsonData), {headers: {'Content-Type': 'application/json'}})
            .then((res) => {
                if (res.data && res.data.status === "200") {
                    if (!ACTIVITY.saveEditSupplier) dispatch(setSaveEditSupplier(true));

                    clearTimeout(timer)
                    let companyDetails = res.data.data;
                    let cloneSupplier = Object.assign({}, editSupplier);
                    cloneSupplier.name = companyDetails?.name !== undefined ? companyDetails?.name : "";
                    cloneSupplier.smallName = companyDetails?.smallName !== undefined ? companyDetails?.smallName : "";
                    cloneSupplier.activity = companyDetails?.activity !== undefined ? companyDetails?.activity : "";
                    cloneSupplier.postalCode = companyDetails?.tk !== undefined ? companyDetails?.tk : "";
                    cloneSupplier.address = companyDetails?.address !== undefined ? companyDetails?.address : "";
                    cloneSupplier.DOY = getDefaultOptionByValue(getDOYOptions(), Number(companyDetails?.doyCode), "value", "label", "value").value;
                    cloneSupplier.city = companyDetails?.city !== undefined ? companyDetails?.city : "";
                    if (companyDetails?.vatCategory === 'Y') {
                        cloneSupplier.vatCategory = 'Normal VAT';
                    }
                    let updatedContactPoints = cloneSupplier.contactPoints.slice();
                    let newContacts = {
                        name: cloneSupplier.name,
                        email: cloneSupplier.email,
                        mobile: cloneSupplier.phone,
                    };
                    updatedContactPoints["0"] = {
                        ...updatedContactPoints["0"],
                        ...newContacts,
                    };
                    let defaultInstallation = [
                        {
                            id: 0,
                            no: 0,
                            type: getMainInstallation()?.value,
                            address: cloneSupplier.address,
                            DOY: cloneSupplier.DOY,
                            city: cloneSupplier.city,
                            county: cloneSupplier.county,
                            vatCategory: cloneSupplier.vatCategory,
                            vatReason: cloneSupplier.vatReason,
                            customVat: cloneSupplier.customVat,
                            postalCode: cloneSupplier.postalCode
                        },
                    ];
                    let updatedInstallations = cloneSupplier.installations.slice();
                    updatedInstallations["0"] = {
                        ...updatedInstallations["0"],
                        ...defaultInstallation,
                    };
                    dispatch(setEditSupplier({
                        ...cloneSupplier,
                        contactPoints: updatedContactPoints,
                        installations: updatedInstallations
                    }));
                    toast.success(res.data.message);
                } else {
                    toast.error(res.data.message);
                }
                setLoadingTaxis(false);
            })
            .catch((error) => {
                setLoadingTaxis(false);
                console.log(error.response?.status);
                if (error.response?.status === 400) {
                    alert({
                        message: error.response.data?.Error ? error.response.data?.Error : error?.message === "timeout" ? "Timeout. Please try again later!" : error.code,
                        type: 'warning',
                    })
                }
            });
    }
    const handleOnChange = async (e, type = "default", ddname = '') => {
        setShowErrors(true);
        if (!ACTIVITY.saveEditSupplier) dispatch(setSaveEditSupplier(true));

        let name;
        let value;
        if (type === 'dd') {
            name = ddname;
            value = e.value;
        } else if (type === 'ac') {
            name = ddname;
            value = e.row.value;
        } else {
            name = e.target.name;
            value = e.target.value;
        }
        if (name === 'customVat') {
            if (+value > 100) {
                toast.error('Can not be greater than 100.');
                value = "";
            }
            value = +parseFloat(value).toFixed(1);
            if (value === 0) {
                value = "";
            }
        }
        // Set settings data
        let cloneSupplier = Object.assign({}, editSupplier);
        let editSupplierData = {};
        if (name === 'category') {
            editSupplierData[name] = value;
            editSupplierData.categoryName = getLabelByValue(supplierCategoriesOption, value, 'value');
            const selectedCategory = findObjectFromArrayOfObjects(supplierCategories, value, '_id');
            if (selectedCategory) {
                editSupplierData.categoryMaskCodePrefix = selectedCategory.maskCodePrefix;
                editSupplierData.systemCode = getGeneratedMaskCodeCLient(selectedCategory._id, supplierCategories, selectedCategory.maskCodePrefix); // New With Updated Prefix
                editSupplierData.accounting = selectedCategory.accounting ? selectedCategory.accounting : '';
                editSupplierData.bypassAccounting = selectedCategory.bypassAccounting ? selectedCategory.bypassAccounting : '';
            }
            // If Category: Retail: Add 000000000, do not validate VAT number. Field not mandatory
            if (editSupplierData.categoryName === 'Retail') {
                editSupplierData.vatNumber = "000000000";
            } else {
                editSupplierData.vatNumber = "";
            }
            if (editSupplierData.categoryName === "Supplier within E.U.") {
                // Update country list for inside EU.
                // Supplier inside E.U., show only countries within E.U. except Greece
                countriesList = getCountryOptions("insideEU");
            } else if (editSupplierData.categoryName === "Supplier outside E.U.") {
                // Update country list for outside EU
                // outside E.U., show only countries outside E.U.
                countriesList = getCountryOptions("outsideEU");
            } else if (editSupplierData.categoryName === "Retail") {
                countriesList = getCountryOptions('all');
                editSupplierData.country = "GR";
            } else {
                // Retail, Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.:
                // Select Greece, Accept only Greece, show only Greece
                countriesList = getCountryOptions("greece");
            }
        } else {
            editSupplierData[name] = value;
        }
        vatCategoryList = (editSupplier.categoryName === "Supplier within E.U." || editSupplier.categoryName === "Supplier outside E.U." || (editSupplier.categoryName === "Retail" && editSupplier.country !== "GR")) ? getVatCategoryAbroadOptions() : getVatCategoryOptions();
        let updatedContactPoints = editSupplier.contactPoints.slice();
        let newContacts = {
            name: editSupplier.name,
            email: editSupplier.email,
            mobile: editSupplier.phone
        }
        if (e) {
            if (name === "name") {
                newContacts["name"] = value;
            } else if (name === "email") {
                newContacts["email"] = value;
            } else if (name === "phone") {
                newContacts["mobile"] = value;
            } else if (name === "category") {
                newContacts["mobile"] = "";
            }
        }
        updatedContactPoints["0"] = {
            ...updatedContactPoints["0"],
            ...newContacts,
        };
        cloneSupplier = {...cloneSupplier, ...editSupplierData}
        // Default Installation
        let defaultInstallation = [{
            id: 0,
            no: 0,
            type: getMainInstallation()?.value,
            address: cloneSupplier.address,
            DOY: cloneSupplier.DOY,
            city: cloneSupplier.city,
            county: cloneSupplier.county,
            vatCategory: cloneSupplier.vatCategory,
            vatReason: cloneSupplier.vatReason,
            customVat: cloneSupplier.customVat,
            postalCode: cloneSupplier.postalCode
        }]
        let updatedInstallations = cloneSupplier.installations.slice();
        updatedInstallations["0"] = {
            ...updatedInstallations["0"],
            ...defaultInstallation,
        };
        dispatch(setEditSupplier({
            ...cloneSupplier,
            contactPoints: updatedContactPoints,
            installations: updatedInstallations
        }));
    }

    const handleClickOpenSupplierMovementsReport = () => {
        dispatch(setSupplierMovementsSearchByBalance({
            _id: editSupplier._id,
            clientName: editSupplier.name
        }));
        dispatch(openSupplierMovementsReport(TABS_DATA));
    }

    // It will hide or show the table columns for searchtable.
    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    const parentMydataActions = {
        insert: (e, data) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditSupplier) {
                dispatch(setSaveEditSupplier(true));
            }
            let tempContactPoint = Object.assign({}, SUPPLIERS_DATA.newContactPoint);
            if (e.key !== "Enter") {
                tempContactPoint[data.field] = data.value;
                dispatch(setEditContactPoint(tempContactPoint)); // Update redux
                if (data.value !== '') {
                    let updatedContactPoint = Object.assign({}, tempContactPoint);
                    let oldContactPoints = editSupplier.contactPoints;
                    updatedContactPoint.no = oldContactPoints.length + 1;
                    updatedContactPoint.id = oldContactPoints.length + 1;
                    dispatch(setEditSupplier({
                        ...editSupplier,
                        contactPoints: [...oldContactPoints, updatedContactPoint]
                    }));
                    dispatch(setEditContactPoint(SUPPLIERS_DATA.newContactPointInitialValue)); // Reset new category mydata
                }
            }
            if (e.key === "Enter" && data.value === "add") {
                let updatedContactPoint = Object.assign({}, tempContactPoint);
                let oldContactPoints = editSupplier.contactPoints;
                updatedContactPoint.no = oldContactPoints.length + 1;
                updatedContactPoint.id = oldContactPoints.length + 1;
                dispatch(setEditSupplier({
                    ...editSupplier,
                    contactPoints: [...oldContactPoints, updatedContactPoint]
                }));
                dispatch(setEditContactPoint(SUPPLIERS_DATA.newContactPointInitialValue)); // Reset new category mydata
            }
        },
        update: (data, id) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditSupplier) {
                dispatch(setSaveEditSupplier(true));
            }

            if (data.name && (data.name.length === 0)) {
                toast.error("Contact Name is mandatory field.");
            } else {
                setSaveEditSupplier(true);
                let contactPoints = editSupplier.contactPoints.slice();
                if (contactPoints.find(item => item.id === id) !== undefined) {
                    contactPoints[id - 1] = {...contactPoints[id - 1], ...data};
                    dispatch(setEditSupplier({...editSupplier, contactPoints: contactPoints})); // update data
                }
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditSupplier) {
                dispatch(setSaveEditSupplier(true));
            }

            let contactPoints = editSupplier.contactPoints.slice();
            if (rowIndex !== 0 && contactPoints.length >= 2) {
                contactPoints.splice(rowIndex, 1);
                const updatedContactPoints = contactPoints.map((item, index) => ({
                    ...item,
                    no: index + 1,
                    id: index + 1
                }));
                dispatch(setEditSupplier({...editSupplier, contactPoints: updatedContactPoints}));
            } else {
                toast.error('First row can not be deleted.');
            }
        }
    }

    const bankInfoTableActions = {
        insert: (e, data) => {
            let tempBankInfo = Object.assign({}, SUPPLIERS_DATA.editBankInfo);
            if (e.key !== "Enter") {
                tempBankInfo[data.field] = data.value;
                dispatch(setEditBankInfo(tempBankInfo));
                let oldBankInfo = editSupplier?.bankInfo || [];
                let updatedBankInfo = Object.assign({}, tempBankInfo);
                if (updatedBankInfo && updatedBankInfo.bankFriendlyName !== '' && updatedBankInfo.bankInstitute !== '' && updatedBankInfo.iban !== '') {
                    dispatch(setEditSupplier({
                        ...editSupplier,
                        bankInfo: [...oldBankInfo, updatedBankInfo]
                    }));
                    dispatch(resetEditBankInfo());
                    dispatch(setSaveEditSupplier(true));
                }
            } else {
                let updatedBankInfo = Object.assign({}, SUPPLIERS_DATA.newBankInfo);
                let oldBankInfo = editSupplier?.bankInfo || [];
                if (e.key === "Enter" || data.value === "add") {
                    if (updatedBankInfo && updatedBankInfo.bankFriendlyName !== '' && updatedBankInfo.bankInstitute !== '' && updatedBankInfo.iban !== '') {
                        dispatch(setEditSupplier({
                            ...editSupplier,
                            bankInfo: [...oldBankInfo, updatedBankInfo]
                        }));
                        dispatch(resetEditBankInfo());
                        dispatch(setSaveEditSupplier(true));
                    }
                }
            }
        },
        update: (data, id, rowIndex) => {
            if (!ACTIVITY.saveEditSupplier) {
                dispatch(setSaveEditSupplier(true));
            }

            let bankInfo = editSupplier.bankInfo.slice();
            bankInfo[rowIndex] = {...bankInfo[rowIndex], ...data};
            dispatch(setEditSupplier({...editSupplier, bankInfo: bankInfo})); // update data
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditSupplier) dispatch(setSaveEditSupplier(true));

            let bankInfo = editSupplier.bankInfo.slice();
            bankInfo.splice(rowIndex, 1);
            dispatch(setEditSupplier({...editSupplier, bankInfo: bankInfo}));
        }
    }

    return (
        <div className="new-supplier-general product-form position-relative">
            {disabledFields && (
                <div className="overlay_w">{t("Required.selectCategoryFirst")}</div>
            )}
            <Row className="position-relative border-bottom mb-3">
                <Col xs="12" md="12" className="d-flex align-items-center justify-content-end ">
                    <div className="inline-field d-flex align-items-center mb-2 mr-5">
                        <Button size={"sm"} className={"mr-2"} onClick={() => handleClickOpenSupplierMovementsReport()}>
                            Προβολή καρτέλας Προμηθευτή
                        </Button>
                        <Input
                            name="productInventoryBalance"
                            className="mb-2 w-100"
                            label={t("General.supplierBalance")}
                            value={(typeof (editSupplier.balance) !== 'undefined') ? Number(editSupplier.balance).toFixed(2) : 0}
                            disabled={true}
                        />
                    </div>
                    <div className="inline-field d-flex align-items-center acremd  mb-3">
                        <label htmlFor="supplier-active" className="mb-0 mr-2 ">
                            {t("General.activeSupplier")}
                        </label>
                        <Checkbox
                            className="mb-2"
                            name="isActive"
                            key={Math.random()}
                            id="supplier-active"
                            defaultValue={editSupplier.isActive}
                            value={editSupplier.isActive === "active" ? "inactive" : "active"}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </div>
                </Col>
            </Row>
            {/* First Row */}
            <Row>
                <Col sm="12" md="3" className="showWithOverlay">
                    <Dropdown
                        label={t("General.category")}
                        required={true}
                        isCLientCategory={true}
                        options={supplierCategoriesOption}
                        classes="w-100 mb-3"
                        name="category"
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(supplierCategories, editSupplier.category, "_id", "category", "_id")}
                        onChange={(e) => handleOnChange(e, "dd", "category")}
                    />
                </Col>
                <Col sm="12" md="3">
                    <Input
                        label={t("General.systemCode")}
                        className="mb-3 w-100"
                        disabled={true}
                        name="systemCode"
                        value={editSupplier.systemCode}
                    />
                </Col>
                <Col sm="12" md="3">
                    <Input
                        label={t("General.manualCode")}
                        className="mb-3 w-100"
                        name="manualCode"
                        type="text"
                        value={editSupplier.manualCode}
                        placeholder="eg. mcc-001"
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={3}>
                    <Dropdown
                        name={"tags"}
                        label={"Ετικέτες"}
                        multiSelect={true}
                        options={tagOptions}
                        defaultValue={tagOptions.filter((el) => (editSupplier?.tags || []).includes(el.value))}
                        onChange={(e) => {
                            if (!ACTIVITY.saveEditSupplier) dispatch(setSaveEditSupplier(true));
                            dispatch(setEditSupplier({...editSupplier, tags: e.map((o) => o.value)}))
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="4">
                    <div className="mb-3">
                        <Input
                            label={t("General.name")}
                            required={true}
                            className="w-100"
                            name="name"
                            type="text"
                            value={editSupplier.name}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {showErrors && editSupplier.name === "" && (
                            <div className="text-danger">{t("Required.name")}</div>
                        )}
                    </div>
                </Col>
                {editSupplier.categoryName !== "" &&
                    editSupplier.categoryName !== "Retail" &&
                    <Col sm="12" md="4">
                        <Input
                            label={t("General.smallName")}
                            className="mb-3 w-100"
                            name="smallName"
                            type="text"
                            value={editSupplier.smallName}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                }
                <Col sm="12" md="4">
                    <div className="mb-3">
                        <Dropdown
                            label={t("General.vatCategory")}
                            classes="w-100"
                            required={true}
                            name="vatCategory"
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(vatCategoryList, editSupplier.vatCategory, "value", "label", "value")}
                            options={vatCategoryList}
                            onChange={(e) => handleOnChange(e, "dd", "vatCategory")}
                        />
                        {showErrors && editSupplier.vatCategory === "" && (
                            <div className="text-danger">{t("Required.vatCategory")}</div>
                        )}
                    </div>
                </Col>
                {(editSupplier.vatCategory !== "" && editSupplier.vatCategory === 'Zero VAT') && (
                    <Col sm="12" md="4">
                        <div className="mb-3">
                            <Dropdown
                                classes='w-100'
                                label={t("General.0vatReason")}
                                key={Math.random()}
                                name="vatReason"
                                required={true}
                                options={zeroVatReasonOptions}
                                defaultValue={editSupplier.vatReason ? {
                                    value: editSupplier.vatReason,
                                    label: getLabelByValue(zeroVatReasonOptions, editSupplier.vatReason, 'value'),
                                    color: "#76AEB7"
                                } : null}
                                onChange={(e) => handleOnChange(e, 'dd', 'vatReason')}
                            />
                            {showErrors && editSupplier.vatCategory === 'Zero VAT' && editSupplier.vatReason === "" && (
                                <div className="text-danger">{t("Required.0vatReason")}</div>
                            )}
                        </div>
                    </Col>
                )}
                {(editSupplier.vatCategory !== "" && editSupplier.vatCategory === 'Custom VAT') &&
                    <Col xs="12" md="4">
                        <div className="mb-3">
                            <Input
                                name="customVat"
                                type="number"
                                validate={isValidCustomVat}
                                label={t("General.customVat")}
                                charLimit={3}
                                onChange={(e) => handleOnChange(e)}
                                value={editSupplier.customVat}
                            />
                            {(editSupplier.vatCategory === 'Custom VAT' &&
                                    editSupplier.customVat === "") &&
                                <div className="text-danger">{t("Required.customVat")}</div>
                            }
                        </div>
                    </Col>
                }
            </Row>
            <Row>
                {(editSupplier.categoryName === "Retail") && (
                    <Col sm="12" md="4">
                        <Input
                            label={t('General.vatNumber')}
                            className="mb-3 w-100 bg-white"
                            name="vatNumber"
                            type="text"
                            defaultValue={editSupplier.vatNumber}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                )}
                {/* Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.: Validate VAT number, use "Get Details" button to get company details. Mandatory field */}
                {(editSupplier.categoryName === "Freelancer" ||
                    editSupplier.categoryName === "O.E." ||
                    editSupplier.categoryName === "E.E." ||
                    editSupplier.categoryName === "E.P.E." ||
                    editSupplier.categoryName === "I.K.E." ||
                    editSupplier.categoryName === "A.E." ||
                    editSupplier.categoryName === 'Wholesale Others' ||
                    editSupplier.categoryName === "Non-Profit Organization" ||
                    editSupplier.categoryName === "Supplier within E.U." ||
                    editSupplier.categoryName === "Supplier outside E.U.") && (
                    <Col sm="12" md="4">
                        <div className="mb-3">
                            <Input
                                label={t('General.vatNumber')}
                                className="w-100 bg-white"
                                name="vatNumber"
                                required={true}
                                charLimit={20}
                                type="text"
                                value={editSupplier.vatNumber}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {showErrors && editSupplier.vatNumber === "" && (
                                <div className="text-danger">{t("Required.vatNumber")}</div>
                            )}
                        </div>
                    </Col>
                )}
                {/* Show only if category is NOT Retail or Patient */}
                {/* Use "Get Greek Company Details from taxisnet" algorithm */}
                {editSupplier.categoryName !== "" &&
                    editSupplier.categoryName !== "Retail" &&
                    editSupplier.categoryName !== "Supplier within E.U." &&
                    editSupplier.categoryName !== "Supplier outside E.U." && (
                        <Col sm="12" md="2" className="d-flex align-items-center">
                            <Button
                                onClick={() => fetchTaxisNetDetails(editSupplier.vatNumber)}
                                size="sm"
                                className="mb-3"
                                type="button"
                                disabled={loadingTaxis}
                            >
                                {t("General.autofillData")} {loadingTaxis && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                            </Button>
                        </Col>
                    )}
                {editSupplier.categoryName === "Supplier within E.U." && (
                    <Col sm="12" md="2" className="d-flex align-items-center">
                        <Button
                            onClick={() => fetchViesDetails(editSupplier.vatNumber, editSupplier.country)}
                            size="sm"
                            className="mb-3"
                            type="button"
                            disabled={loadingTaxis}
                        >
                            VIES Check {loadingTaxis && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Col>
                )}
                {(editSupplier.categoryName === "Freelancer" ||
                    editSupplier.categoryName === "O.E." ||
                    editSupplier.categoryName === "E.E." ||
                    editSupplier.categoryName === "E.P.E." ||
                    editSupplier.categoryName === "I.K.E." ||
                    editSupplier.categoryName === "A.E." ||
                    editSupplier.categoryName === "Non-Profit Organization" ||
                    editSupplier.categoryName === 'Wholesale Others') && (
                    <Col sm="12" md="3">
                        <Dropdown
                            label={t("General.doy")}
                            classes="w-100"
                            required={
                                editSupplier.categoryName !== "Retail" &&
                                editSupplier.categoryName !== "Supplier within E.U." &&
                                editSupplier.categoryName !== "Supplier outside E.U."
                            }
                            searchEnable={true}
                            name="DOY"
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(getDOYOptions(), Number(editSupplier.DOY), "value", "label", "value")}
                            options={getDOYOptions()}
                            onChange={(e) => handleOnChange(e, "dd", "DOY")}
                        />
                        {
                            editSupplier.categoryName !== "Retail" &&
                            editSupplier.categoryName !== "Supplier within E.U." &&
                            editSupplier.categoryName !== "Supplier outside E.U." &&
                            showErrors &&
                            editSupplier.DOY === "" && (
                                <div className="text-danger">{t("Required.doy")}</div>
                            )}
                    </Col>)}
                {(editSupplier.categoryName === "Freelancer" ||
                    editSupplier.categoryName === "O.E." ||
                    editSupplier.categoryName === "E.E." ||
                    editSupplier.categoryName === "E.P.E." ||
                    editSupplier.categoryName === "I.K.E." ||
                    editSupplier.categoryName === "A.E." ||
                    editSupplier.categoryName === "Non-Profit Organization" ||
                    editSupplier.categoryName === 'Wholesale Others') && (
                    <Col sm="12" md="3">
                        <Input
                            label={t("General.activity")}
                            className="w-100"
                            name="activity"
                            type="text"
                            charLimit={100}
                            required={editSupplier.categoryName !== "Retail"}
                            value={editSupplier.activity}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {showErrors && editSupplier.activity === "" && (
                            <div className="text-danger">{t("Required.activity")}.</div>)}
                    </Col>
                )}
            </Row>
            <Row>
                <Col sm="12" md="3">
                    {/* Mandatory field EXCEPT if category retail & patient */}
                    <Dropdown
                        label={t("General.country")}
                        classes="w-100"
                        required={editSupplier.categoryName !== "Retail"}
                        name="country"
                        searchEnable={true}
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(countriesList, editSupplier.country, "value", "label", "value")}
                        options={countriesList}
                        onChange={(e) => handleOnChange(e, "dd", "country")}
                    />
                    {
                        showErrors &&
                        editSupplier.country === "" && (
                            <div className="text-danger">{t("Required.country")}</div>
                        )}
                </Col>
                <Col sm="12" md="3">
                    <div className="mb-3">
                        {/* Mandatory field EXCEPT if category retail & patient */}
                        <Input
                            label={t("General.address")}
                            className="w-100"
                            name="address"
                            type="text"
                            charLimit={100}
                            required={editSupplier.categoryName !== "Retail"}
                            value={editSupplier.address}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {
                            showErrors && editSupplier.categoryName !== "Retail" &&
                            editSupplier.address === "" && (
                                <div className="text-danger">{t("Required.address")}</div>
                            )}
                    </div>
                </Col>
                <Col sm="12" md="3">
                    <div className="mb-3">
                        {/* Mandatory field EXCEPT if category retail & patient */}
                        <Input
                            label={t("General.city")}
                            className="w-100"
                            name="city"
                            type="text"
                            charLimit={100}
                            required={editSupplier.categoryName !== "Retail"}
                            value={editSupplier.city}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {
                            showErrors && editSupplier.categoryName !== "Retail" &&
                            editSupplier.city === "" && (
                                <div className="text-danger">{t("Required.city")}</div>
                            )}
                    </div>
                </Col>
                <Col sm="12" md="3">
                    {/* Mandatory field EXCEPT if category retail & patient */}
                    <div className="mb-3">
                        <Input
                            label={t("General.postalCode")}
                            className="w-100"
                            name="postalCode"
                            type="text"
                            required={editSupplier.categoryName !== "Retail"}
                            value={editSupplier.postalCode}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {
                            showErrors && editSupplier.categoryName !== "Retail" &&
                            editSupplier.postalCode === "" && (
                                <div className="text-danger">{t("Required.postalCode")}</div>
                            )}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="3">
                    <div className="mb-3">
                        <Input
                            label={t("General.email")}
                            className="w-100"
                            name="email"
                            type="email"
                            value={editSupplier.email}
                            placeholder="eg. example@example.com"
                            onChange={(e) => handleOnChange(e)}
                            required={editSupplier.phone === ""}
                        />
                        {showErrors &&
                            editSupplier.email !== "" &&
                            !isValidEmail(editSupplier.email) && (
                                <div className="text-danger">{t("Required.invalidEmail")}</div>
                            )}

                        {showErrors &&
                            editSupplier.categoryName !== "Patient" &&
                            editSupplier.categoryName !== "I.K.E." &&
                            editSupplier.categoryName !== "Freelancer" &&
                            editSupplier.categoryName !== "O.E." &&
                            editSupplier.categoryName !== "E.E." &&
                            editSupplier.categoryName !== "A.E." &&
                            editSupplier.categoryName !== "Non-Profit Organization" &&
                            editSupplier.categoryName !== "E.P.E." &&
                            editSupplier.categoryName !== "Wholesale Others" &&
                            editSupplier.email === "" &&
                            editSupplier.phone === "" && (
                                <div className="text-danger">{t("Required.emailOrPhone")}</div>
                            )}
                    </div>
                </Col>
                <Col sm="12" md="3">
                    <Input
                        label={t("General.phone")}
                        className="mb-3 w-100"
                        name="phone"
                        type="tel"
                        charLimit={20}
                        value={editSupplier.phone}
                        onChange={(e) => handleOnChange(e)}
                        required={editSupplier.email === ""}
                    />
                </Col>
                <Col sm="12" md="3">
                    <Input
                        label={t("General.gemhNo")}
                        className="mb-3 w-100"
                        name="gemhNo"
                        type="text"
                        value={editSupplier.gemhNo}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col sm="12" md="3">
                    <Input
                        label={t("General.webpage")}
                        className="mb-3 w-100"
                        name="webpage"
                        type="url"
                        value={editSupplier.webpage}
                        placeholder="eg. https://www.example.com/"
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
            <hr/>
            <p className="text-muted">
                <i>{t("General.contactPoints")}</i>
            </p>
            <EditableTable
                tableName="Supplier Contact Points"
                key={Math.random()}
                allowActions={true}
                allowToggleColumns={true}
                toggleColumns={handleColumnShowHide}
                columns={tableColumns}
                data={editSupplier.contactPoints}
                allowInsertRow={true}
                enableNewRowCheckbox={true}
                onUpdate={parentMydataActions}
            />
            <p className="text-muted"><i>{t('ClientsGeneralEdit.bankInfoTable.title')}</i></p>
            <EditableTable
                tableName="Edit Supplier Bank Info"
                key={"Edit Supplier Bank Info" + bankInfoIncrKey}
                allowActions={true}
                columns={bankInfoTableColumns}
                data={editSupplier.bankInfo}
                allowInsertRow={true}
                enableNewRowCheckbox={true}
                onUpdate={bankInfoTableActions}
            />

            <p>
                <i>{t("General.notes")}</i>
            </p>
            <TextArea
                className="mb-3"
                rows="4"
                name="supplierNotes"
                limit="1000"
                value={editSupplier.supplierNotes}
                placeholder={t("Placeholders.notes")}
                onChange={(e) => handleOnChange(e)}
            />
        </div>
    )
}

export const SuppliersEditLog = ({tabKey}) => {
    const {t} = useTranslation();
    const editSupplier = useSelector((state) => state.SUPPLIERS_DATA.editSupplier[tabKey]);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.supplierLog')}</i></div>
            <LogTable itemId={editSupplier._id}/>
        </React.Fragment>
    )
}

export default EditSupplierGeneral;
